import axios from '@utils/axios';

const viewMoneyDetail = {
  state: {
    moneyVoucherId: 0,
    amount: 0,
    voucherType: 1,
    fromWho: '',
    forWho: '',
    validTo: '',
    code: '',
    redeemed: false
  },
  mutations: {
    setMoneyVoucherId(state, val) {
      state.moneyVoucherId = val;
    },
    setAmount(state, val) {
      state.amount = val;
    },
    setVoucherType(state, val) {
      state.voucherType = val;
    },
    setFromWho(state, val) {
      state.fromWho = val;
    },
    setForWho(state, val) {
      state.forWho = val;
    },
    setValidTo(state, val) {
      state.validTo = val;
    },
    setCode(state, val) {
      state.code = val;
    },
    setRedeemed(state, val) {
      state.redeemed = val;
    }
  },
  actions: {
    fetchMoneyVoucher(context) {
      return axios.get('admin/vouchers/getmoneyvoucher', {
        params: {
          Id: context.state.moneyVoucherId
        }
      }).then((res) => {
        context.commit('setAmount', res.data.result.amount);
        context.commit('setVoucherType', res.data.result.voucherType);
        context.commit('setFromWho', res.data.result.fromWho);
        context.commit('setForWho', res.data.result.forWho);
        context.commit('setValidTo', res.data.result.validTo);
        context.commit('setCode', res.data.result.code);
        context.commit('setRedeemed', res.data.result.redeemed);
      });
    },
    resetContext(context) {
      context.commit('setAmount', 0);
      context.commit('setVoucherType', 1);
      context.commit('setFromWho', '');
      context.commit('setForWho', '');
      context.commit('setValidTo', '');
      context.commit('setCode', '');
      context.commit('setRedeemed', false);
    },
  },
  namespaced: true
};

export default viewMoneyDetail;
